import { CaseItemKeys } from "src/pages/UserDashboard/Cases/mappers/mapServerToLocalCase.ts";
import { CaseType } from "src/pages/UserDashboard/WorkPackets/Cases/case-types.ts";

export type CaseItemKind = "shortage-escalation" | "shortage-settlement" | "chargeback-escalation";
export interface BaseCaseItem {
  kind: CaseItemKind;
  [CaseItemKeys.CaseId]: string;
  [CaseItemKeys.CaseType]: CaseType;
  [CaseItemKeys.CaseItemId]: string;
  [CaseItemKeys.WorkPacketId]: string;
  [CaseItemKeys.ARN]: string;
  [CaseItemKeys.ASN]: string;
}

export interface ShortageEscalationCaseItem extends BaseCaseItem {
  kind: "shortage-escalation";
  [CaseItemKeys.RemainingOpenBalance]: number | undefined;
  [CaseItemKeys.CaseItemStatus]: string;
  [CaseItemKeys.DeniedReason]?: string | undefined;
  [CaseItemKeys.VcParentInvoiceId]: string;
  [CaseItemKeys.VcDisputedInvoiceId]: string;
  [CaseItemKeys.LastChildInvoiceId]?: string;
  [CaseItemKeys.OSSRWorkPacketId]: string | undefined;
  [CaseItemKeys.PoNumber]: string;
  [CaseItemKeys.ApprovedAmount]: number | undefined;
  [CaseItemKeys.ShortagesEscalationCaseItemDetailId]: string;
  [CaseItemKeys.ShortagesEscalationCaseDetailsId]: string;
}

export interface ChargebackEscalationCaseItem extends BaseCaseItem {
  kind: "chargeback-escalation";
  [CaseItemKeys.FinancialCharge]: string | undefined;
  [CaseItemKeys.ChargeBackIssueId]: string;
  [CaseItemKeys.ChargebacksEscalationCaseItemDetailId]: string;
  [CaseItemKeys.CaseItemStatus]: string;
  [CaseItemKeys.DeniedReason]?: string | undefined;
  [CaseItemKeys.ApprovedAmount]?: number | undefined;
  [CaseItemKeys.ApprovedDate]?: Date | undefined;
  [CaseItemKeys.ASIN]: string;
  [CaseItemKeys.PoNumber]: string;
}

export interface ShortageSettlementCaseItem extends BaseCaseItem {
  kind: "shortage-settlement";
  [CaseItemKeys.VcDisputedInvoiceId]: string;
  [CaseItemKeys.LastChildInvoiceId]?: string;
  [CaseItemKeys.OSSRWorkPacketId]: string | undefined;
  [CaseItemKeys.PoNumber]: string;
}

export type CaseItem = ShortageEscalationCaseItem | ShortageSettlementCaseItem | ChargebackEscalationCaseItem;

export const isShortageEscalationCaseItem = (item: CaseItem): item is ShortageEscalationCaseItem =>
  item["kind"] === "shortage-escalation";

export const isShortageSettlementCaseItem = (item: CaseItem): item is ShortageSettlementCaseItem =>
  item["kind"] === "shortage-settlement";

export const isChargebackEscalationCaseItem = (item: CaseItem): item is ChargebackEscalationCaseItem =>
  item["kind"] === "chargeback-escalation";
